// extracted by mini-css-extract-plugin
module.exports = {"title":"CustomBreadcrumb_title__2n3aG","children":"CustomBreadcrumb_children__3ZbfG"};